import { ComponentProps } from 'react';
import Tabs from 'antd/es/tabs';
import clsx from 'clsx';

import './OpTabs.scss';

/**
 * OpTabs is a wrapper around Ant Design's Tabs component.
 * It provides a tabbed interface for organizing content into multiple panels.
 *
 * Use this component to organize related content across different views or sections,
 * allowing users to switch between them without leaving the page. Defaults to small size.
 *
 * @example
 * <OpTabs
 *   items={[
 *     { key: '1', label: 'Tab 1', children: <div>Content 1</div> },
 *     { key: '2', label: 'Tab 2', children: <div>Content 2</div> },
 *   ]}
 * />
 *
 */
export const OpTabs = ({
  size = 'small',
  className = '',
  fillContainerHeight = false,
  ...tabProps
}: ComponentProps<typeof Tabs> & { fillContainerHeight?: boolean }) => (
  <Tabs
    className={clsx('op-tabs', className, {
      'op-tabs--fill-container-height': fillContainerHeight,
    })}
    size={size}
    {...tabProps}
  />
);
